import moment from 'moment';
import { dateFormat, timeFormat, longTimeFormat } from '../config';

export const formatLongDateTime = (date) => {
	const momentDate = moment(date);
	const time = momentDate.minute() === 0 ? momentDate.format(timeFormat) : momentDate.format(longTimeFormat);
	return `${momentDate.format(dateFormat)} at ${time}`;
};

export const isDateToday = (date, todaysDate) => {
	if (moment.isMoment(date)) return date.isSame(todaysDate, 'day');
	return false;
};
export const formattedDate = (date, dateFormat) => moment(date).format(dateFormat);
